module.exports = __webpack_public_path__ + "assets/img/coin-gct-bj.aed4d379.jpg";